import { render, staticRenderFns } from "./RegistrationLink.vue?vue&type=template&id=7f79f3f3&"
import script from "./RegistrationLink.vue?vue&type=script&lang=ts&"
export * from "./RegistrationLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports